export const MAIN_LIST_SUCCESS = 'MAIN_LIST_SUCCESS';
export const MAIN_GET_MODES_FILTER = 'MAIN_GET_MODES_FILTER';
export const MAIN_GET_MODES_FILTER_SUCCESS = 'MAIN_GET_MODES_FILTER_SUCCESS';
export const MAIN_GET_MODES_FILTER_ERROR = 'MAIN_GET_MODES_FILTER_ERROR';
export const MAIN_GET_MODES_FILTER_CLEAR = 'MAIN_GET_MODES_FILTER_CLEAR';
export const MAIN_GET_SERVICE_FILTER = 'MAIN_GET_SERVICE_FILTER';
export const MAIN_GET_SERVICE_FILTER_SUCCESS = 'MAIN_GET_SERVICE_FILTER_SUCCESS';
export const MAIN_GET_SERVICE_FILTER_ERROR = 'MAIN_GET_SERVICE_FILTER_ERROR';
export const MAIN_LOADING_TABLE = 'MAIN_LOADING_TABLE';
export const MAIN_LIST_UPDATE = 'MAIN_LIST_UPDATE';
export const MAIN_LIST_UPDATE_ERROR = 'MAIN_LIST_UPDATE_ERROR';
export const MAIN_LIST_UPDATE_SUCCESS = 'MAIN_LIST_UPDATE_SUCCESS';
export const MAIN_PAGINATION_UPDATE = 'MAIN_PAGINATION_UPDATE';
export const MAIN_PAGINATION_UPDATE_SUCCESS = 'MAIN_PAGINATION_UPDATE_SUCCESS';
export const MAIN_MODAL_CLOSE = 'MAIN_MODAL_CLOSE';
export const MAIN_MODAL_OPEN = 'MAIN_MODAL_OPEN';
export const MAIN_CHANGE_STATUS_SUCCESS = 'MAIN_CHANGE_STATUS_SUCCESS';
export const MAIN_CHANGE_MASS_STATUS_SUCCESS = 'MAIN_CHANGE_MASS_STATUS_SUCCESS';
export const MAIN_CHECKED = 'MAIN_CHECKED';
